export default __webpack_public_path__ + "static/media/minis_icon_black.92f584b9.svg";